import React, { Component } from 'react';
import { graphql, withApollo, compose } from 'react-apollo';

import { notification, Button } from 'antd/lib';
import * as Icons from '@ant-design/icons';

import CKEditor from 'react-ckeditor-component';

import updateDocumentoPorId from '../../graphql/mutations/common/updateDocumentoPorId.graphql';
import deleteDocumento from '../../graphql/mutations/common/deleteDocumento.graphql';
import getDocumentoPorId from '../../graphql/querys/common/getDocumentoPorId.graphql';

import Loading from '../common/Loading';

import { imprimir } from '../common/funciones/imprimir';

@compose(
  graphql(updateDocumentoPorId, {
    name: 'updateDocumentoPorId',
  }),
  graphql(deleteDocumento, {
    name: 'deleteDocumento',
  })
)
class EditarDocumento extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      documento: {
        _id: '',
        textoHtml: '',
        fechaModificacion: '',
      },
    };
  }

  // eslint-disable-next-line no-unused-vars
  onSubmit = textoHtml => {};

  onCancel = () => {
    //TODO: Agregar un SweetAlert o similar para preguntar si desea volver sin guardar.

    this.props.history.goBack();
  };

  onChange = textoHtml => {
    this.props
      .updateDocumentoPorId({
        variables: {
          _id: this.props.match.params.id,
          nuevoDocumento: { textoHtml },
        },
      })
      // eslint-disable-next-line no-unused-vars
      .then(respuestaUpdate => {
        this.props.history.goBack();
        notification.success({
          message: 'Documento Actualizado',
          description:
            'El documento se actualizo correctamente en la base de datos',
        });
      })
      .catch(err => {
        console.log('Ocurrio un error a la hora de actualizar el documento');
        console.log(err);

        notification.error({
          message: 'Error en la actualizacion',
          description: 'No se logró guardar los cambios en la base de datos',
        });
      });
  };

  onDelete = () => {};

  onImprimir = textoHtml => {
    imprimir(textoHtml);
  };

  getTexto = () => {
    // eslint-disable-next-line react/no-string-refs
    let editor = this.refs.editor.editorInstance;
    return editor.getData();
  };

  componentDidMount() {
    this.props.client
      .query({
        query: getDocumentoPorId,
        variables: { _id: this.props.match.params.id },
      })
      .then(res => {
        let doc = res.data.getDocumentoPorId;

        if (doc) {
          this.setState({
            ...this.state,
            documento: {
              ...doc,
            },
          });
        }
      })
      .catch(err => {
        console.log('Errror a la hora de obtener el documento');
        console.log(err);
      });
  }

  render() {
    if (this.state.loading) {
      return <Loading />;
    }

    return (
      <div>
        <CKEditor
          /* eslint-disable-next-line react/no-string-refs */
          ref="editor"
          activeClass="p10"
          content={this.state.documento.textoHtml}
          scriptUrl={'/ckeditor/ckeditor.js'}
          config={{
            height: 800,
            language: 'es',
            removeButtons:
              'Source,NewPage,Print,Templates,Scayt,Form,Checkbox,Radio,TextField,Textarea,Select,Button,ImageButton,HiddenField,CreateDiv,Smiley,Iframe,About,Flash',
          }}
        />
        <div className="divBotonesEditor">
          <Button
            style={{ margin: 5 }}
            type="primary"
            icon={<Icons.SaveOutlined />}
            size="default"
            onClick={() => this.onChange(this.getTexto())}
          >
            Guardar Cambios
          </Button>
          <Button
            style={{ margin: 5 }}
            icon={<Icons.PrinterOutlined />}
            size="default"
            onClick={() => this.onImprimir(this.getTexto())}
          >
            Imprimir
          </Button>
          <Button
            style={{ margin: 5 }}
            type="danger"
            icon={<Icons.RollbackOutlined />}
            size="default"
            onClick={() => this.onCancel()}
          >
            Cancelar
          </Button>
        </div>
      </div>
    );
  }
}

export default withApollo(EditarDocumento);
